import { PresetFrame, type PresetArtProps } from './PresetFrame';

export function Fox(props: PresetArtProps) {
  return (
    <PresetFrame background="#ea580c" {...props}>
      <path d="M14 14 L27 25 H37 L50 14 L48 34 L32 51 L16 34 Z" fill="#ffffff" />
      <circle cx="25" cy="34" r="2.5" fill="#1f2937" />
      <circle cx="39" cy="34" r="2.5" fill="#1f2937" />
      <circle cx="32" cy="45" r="2.5" fill="#1f2937" />
    </PresetFrame>
  );
}
